import * as React from "react";

type LoadMoreBtnProps = {
    onClick: any;
    loadMoreButtonText: string;
};

export default class LoadMoreBtn extends React.Component<LoadMoreBtnProps, {}> {
    constructor(props: LoadMoreBtnProps) {
        super(props);
    }

    public render() {
        return (
            <div className="article-list--load-more-btn text-center">
                <button className="btn btn-link article-list--btn" onClick={this.props.onClick}>{this.props.loadMoreButtonText}</button>
            </div>
        );
    }
}
